import {
  Grid,
  GridColumn,
  GridRow,
  Header,
  Menu,
  Sidebar,
} from "semantic-ui-react";
import { IItem } from "../../interfaces/Item";
import { DraggableItem } from "./DraggableItem";
import { items } from "../../utils/Items";
import { useTranslation } from "react-i18next";
interface Props {
  setZoom: (i: number) => void;
}
export const ItemsSidebar = ({setZoom}: Props) => {
  const {t} = useTranslation();
  return (
    <Sidebar
      as={Menu}
      animation="push"
      direction="left"
      icon="labeled"
      vertical
      visible={true}
      width="thin"
      style={style.sidebar}
    >
      <Header as="h3">{t("tools")}</Header>
      <Grid columns={1} style={style.grid}>
        <GridRow>
          {items.map((item: IItem, idx: number) => (
            <GridColumn key={idx} style={style.column}> 
              <DraggableItem setZoom={setZoom} item={item} key={idx} />
            </GridColumn>
          ))}
        </GridRow>
      </Grid>
    </Sidebar>
  );
};

const style = {
  grid: {
    padding: "10px 5px",
    width: "100%",
    margin: 0,
  },
  column :{
    margin: "6px 0px"
  },
  sidebar: { 
    paddingTop: 10,
   },
};
